import { render, staticRenderFns } from "./LandingHead.vue?vue&type=template&id=3c49b7b7&scoped=true"
import script from "./LandingHead.vue?vue&type=script&lang=js"
export * from "./LandingHead.vue?vue&type=script&lang=js"
import style0 from "./LandingHead.vue?vue&type=style&index=0&id=3c49b7b7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c49b7b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c49b7b7')) {
      api.createRecord('3c49b7b7', component.options)
    } else {
      api.reload('3c49b7b7', component.options)
    }
    module.hot.accept("./LandingHead.vue?vue&type=template&id=3c49b7b7&scoped=true", function () {
      api.rerender('3c49b7b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingHead.vue"
export default component.exports